module.exports = __webpack_public_path__ + "static/img/button01zh-tw.446b978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/button01zh-tw.png
// module id = oJnr
// module chunks = 1